module.exports = __webpack_public_path__ + "static/media/belasting-7.0148f5c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/belasting-7.svg
// module id = 132
// module chunks = 0